// extracted by mini-css-extract-plugin
export default {"closeIconPrimary":"close-icon_closeIconPrimary__zoCdS","closeIconSecondary":"close-icon_closeIconSecondary__swMP9"};